export interface IGridsterOptions {
    colWidth: string | number; // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
    columns: number; // the width of the grid, in columns
    defaultSizeX: number; // the default width of a gridster item, if not specifed
    defaultSizeY: number; // the default height of a gridster item, if not specified
    draggable:  {
        enabled: boolean;
        start?: (event, uiWidget, $element) => void;
        drag?: (event, uiWidget, $element) => void;
        stop?: (event, uiWidget, $element) => void;
    };
    floating?: boolean;
    margins: number[]; // the pixel distance between each widget
    maxRows: number;
    minRows: number; // the minimum height of the grid, in rows
    mobileBreakPoint: number; // if the screen is not wider that this, remove the grid layout and stack the items
    mobileModeEnabled: boolean;
    outerMargin: boolean;
    push: boolean;
    pushing?: boolean;
    resizable: {
        enabled: boolean;
        handles: string[];
        start?: (event, uiWidget, $element) => void;
        resize?: (event, uiWidget, $element) => void;
        stop?: (event, uiWidget, $element) => void;
    };
    rowHeight: string | number; // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
    sparse?: boolean;
    swapping: boolean;
    width: string | number;
}

export const DefaultGridsterOptions: IGridsterOptions = {
    minRows: 6, // the minimum height of the grid, in rows
    maxRows: 100,
    columns: 12, // the width of the grid, in columns
    width: 'auto',
    colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
    rowHeight: 60, // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
    margins: [8, 8], // the pixel distance between each widget
    defaultSizeX: 6, // the default width of a gridster item, if not specifed
    defaultSizeY: 6, // the default height of a gridster item, if not specified
    mobileBreakPoint: (992 - 240 - 20), // if the screen is not wider that this, remove the grid layout and stack the items
    mobileModeEnabled: true,
    resizable: {
        enabled: false,
        handles: ['n', 'e', 's', 'w', 'se', 'sw', 'ne', 'nw']
    },
    draggable: {
        enabled: false, // whether dragging items is supported
    },
    swapping: true,
    outerMargin: true,
    push: true,
    pushing: true
};